<app-dialog-base [Title]='"Object edit"|translate' [dialogId]="dialogId" (onClose)="close()"
                 (onSubmit)="submit()" [width]="'780px'">
  <div class="btn_tabs">
    <button (click)="openTab('main')" [class.active]="openedTabName == 'main'">{{"Main"|translate}}</button>
    <button (click)="openTab('trends')" [class.active]="openedTabName == 'trends'">{{"Sensors"|translate}}</button>
    <button (click)="openTab('fuel')" [class.active]="openedTabName == 'fuel'">{{"Settings"|translate}}</button>
    <button (click)="openTab('greenDriving')" [class.active]="openedTabName == 'greenDriving'">{{"Green driving" |translate}}</button>
    <button (click)="openTab('servicelog')" [class.active]="openedTabName == 'servicelog'" *ngIf="canAccessComponent(AccessRights.EDITUSERS)">{{"Service log"|translate}}</button>
    <button (click)="openTab('events')" [class.active]="openedTabName == 'events'">{{"Events"|translate}}</button>
    <button *ngIf="!model.HasFlag('PERSONAL')" (click)="openTab('odometer')" [class.active]="openedTabName == 'odometer'">{{"Odometer"|translate}}</button>
    <button *ngIf="!model.HasFlag('STATIC') && !model.HasFlag('PERSONAL')" (click)="openTab('vspecs')" [class.active]="openedTabName == 'vspecs'">{{"Vehicle specs"|translate}}</button>
    <button *ngIf="model.HasFlag('SECURITY')" (click)="openTab('photos')" [class.active]="openedTabName == 'photos'">{{"Photos"|translate}}</button>
  </div>
  <div class="horseparator"></div>
  <div class="tablewrap">
    <div id="main" *ngIf="isSelected('main')">
      <object-main-part [onOpen]="onOpen" [Object]="model" [Groups]="groups" [Commands]="commands" [Keys]="keys" [Icons]="icons"></object-main-part>
    </div>

    <div id="trends" *ngIf="isSelected('trends')">
      <object-trends-part [Object]="model"></object-trends-part>
    </div>

    <div id="fuel" *ngIf="isSelected('fuel')">
      <object-fuel-part [Object]="model"></object-fuel-part>
    </div>

    <div id="servicelog" *ngIf="isSelected('servicelog')">
      <object-servicelog-part [Object]="model"></object-servicelog-part>
    </div>

    <div id="events" *ngIf="isSelected('events')">
      <object-events-part [Object]="model"></object-events-part>
    </div>

    <div id="odometer" *ngIf="isSelected('odometer')">
      <object-odometer-part [Object]="model"></object-odometer-part>
    </div>

    <div id="vspecs" *ngIf="isSelected('vspecs')">
      <app-object-vechile-spec-part [model]="model.VehicleSpecifications"></app-object-vechile-spec-part>
    </div>

    <div id="photos" *ngIf="isSelected('photos')">
      <app-object-photos [Id]="model.Id"></app-object-photos>
    </div>

     <div id="greenDriving" *ngIf="isSelected('greenDriving')">
      <app-object-green-driving [Object]="model"></app-object-green-driving>
    </div>
  </div>
</app-dialog-base>
